import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalContainerComponent } from './modal-container/modal-container.component';
import { ModalService } from './modal.service';

@NgModule({
  declarations: [ModalContainerComponent],
  imports: [
    CommonModule
  ]
})
export class ModalModule {
  static forRoot() {
    return {
      ngModule: ModalModule,
      providers: [
        ModalService
      ]
    }
  }
}
